<template>
  <answer-end-arrow :type="type"
                            :arrow-src="arrowSrc"
                            class="cursor-pointer"
                            @click.native="selectBubble"
                            @mouseover="isHovered = true"
                            @mouseleave="isHovered = false"
  />
</template>

<script>
import arrowIconInactive from '@/assets/images/icons/ending_arrow_icon.svg'
import arrowIconHover from '@/assets/images/icons/ending_arrow_hover.svg'
import arrowIconFocus from '@/assets/images/icons/ending_arrow_focus.svg'
import chatBubbleModule from '@/store/modules/chat-bubble.module'
import AnswerEndArrow from '@/components/common/AnswerEndArrow.vue'

export default {
  name: 'AnswerEnd',

  components: {
    AnswerEndArrow
  },

  props: {
    stateId: { type: String, required: true },
    type: { type: String, required: true },
    focus: { type: Boolean, required: true },
    isTemplate: { type: Boolean, required: true },
    isCondition: { type: Boolean, required: true },
    inNestedCondition: { type: Boolean, default: false },
    conditionEndStateId: { type: String },
    isPostback: { type: Boolean, default: false },
    isQuickReply: { type: Boolean, default: false },
    answerId: { type: String, default: null }
  },

  data() {
    return {
      isHovered: false
    }
  },

  computed: {
    arrowSrc() {
      if (this.focus) return arrowIconFocus
      if (this.isHovered) return arrowIconHover

      return arrowIconInactive
    }
  },

  methods: {
    selectBubble() {
      chatBubbleModule.selectAnswerEnd(
        this.stateId, this.type, this.isTemplate, this.isCondition, this.conditionEndStateId, this.isPostback, this.isQuickReply, this.inNestedCondition, this.answerId
      )
    }
  }
}
</script>

<style scoped lang="scss">

.bubble-shadow {
  // noinspection CssInvalidFunction - theme() belongs to TailWind
  box-shadow: 0 4px 11px 0 theme('colors.focus-a50');
}

.bg-no-repeat {
  background-repeat: no-repeat;
}

.bg-center {
  background-position: center;
}

</style>
